import React, { Component } from 'react';

class TeamJob extends Component {
    render() {

        let data = [
            {
                jobTitle: "Experienced Multi-Disciplinary Team", jobDesc:
                    "Our qualified educators and therapists work together to provide evidence-based interventions, individualized care, and holistic support for every child's unique developmental needs."
            },
            {
                jobTitle: "Comprehensive Therapy & Education", jobDesc:
                    "We offer Early Intervention, Speech Therapy, Occupational Therapy, Play & Language Therapy, Special Education, Learning Support, and Behaviour Modification under one roof."
            },
            {
                jobTitle: "Family-Centered Approach", jobDesc:
                    "We actively involve parents through counselling, guidance, and regular collaboration, ensuring children receive consistent support both at the centre and at home."
            },
            {
                jobTitle: "Inclusive Learning Environment", jobDesc:
                    "We provide a safe, caring, and inclusive environment where every child is respected, encouraged, and empowered to develop confidence, independence, and lifelong skills."
            }
        ];

        let DataList = data.map((val, i) => {
            return (
                <div className="team-job__single" key={i}>
                    <h3 className="title"> <a href={val.jobLink}>{val.jobTitle}</a></h3>
                    <p className="text">{val.jobDesc}</p>
                </div>
            )
        });
        return (
            <div>
                {/*====================  team job area ====================*/}
                <div className="team-job-area section-space--inner--120">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="team-job__content">
                                    <div className="team-job__title-wrapper">
                                        <h2 className="team-job__title">Why Choose Us?</h2>
                                        <button onClick={null} className="see-more-link see-more-link--color">Empowering children with unique abilities to learn, grow, and fly independently.</button>
                                    </div>
                                    <div className="team-job__content-wrapper">
                                        <div className="team-job__list-wrapper">
                                            {DataList}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="team-job__image text-center text-lg-right">
                                    <img src="assets/img/team/team.jpg" className="img-fluid" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*====================  End of team job area  ====================*/}

            </div>
        )
    }
}

export default TeamJob;